<svg
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <circle opacity="0.2" cx="10" cy="10" r="8" fill="currentColor" />
  <path d="M9 1H11V4H9V1Z" fill="currentColor" />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M10 15C12.7614 15 15 12.7614 15 10C15 7.23858 12.7614 5 10 5C7.23858 5 5 7.23858 5 10C5 12.7614 7.23858 15 10 15ZM10 13C11.6569 13 13 11.6569 13 10C13 8.34315 11.6569 7 10 7C8.34315 7 7 8.34315 7 10C7 11.6569 8.34315 13 10 13Z"
    fill="currentColor"
  />
  <path d="M16 11H19V9H16V11Z" fill="currentColor" />
  <path d="M4 9V11H1L1 9H4Z" fill="currentColor" />
  <path d="M9 16V19H11V16H9Z" fill="currentColor" />
  <path
    d="M13.634 1.70577L15.366 2.70577L13.866 5.30385L12.134 4.30385L13.634 1.70577Z"
    fill="currentColor"
  />
  <path
    d="M17.2942 15.366L18.2942 13.634L15.6962 12.134L14.6962 13.866L17.2942 15.366Z"
    fill="currentColor"
  />
  <path
    d="M5.30385 6.13397L4.30385 7.86602L1.70577 6.36602L2.70577 4.63397L5.30385 6.13397Z"
    fill="currentColor"
  />
  <path
    d="M4.63398 17.2942L6.36603 18.2942L7.86603 15.6962L6.13398 14.6962L4.63398 17.2942Z"
    fill="currentColor"
  />
  <path
    d="M17.2935 4.63397L18.2935 6.36602L15.6955 7.86602L14.6955 6.13397L17.2935 4.63397Z"
    fill="currentColor"
  />
  <path
    d="M13.6333 18.2942L15.3653 17.2942L13.8653 14.6961L12.1333 15.6961L13.6333 18.2942Z"
    fill="currentColor"
  />
  <path
    d="M7.86533 4.30384L6.13328 5.30384L4.63328 2.70576L6.36533 1.70576L7.86533 4.30384Z"
    fill="currentColor"
  />
  <path
    d="M1.70508 13.634L2.70508 15.366L5.30315 13.866L4.30315 12.134L1.70508 13.634Z"
    fill="currentColor"
  />
</svg>
